import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useMemo,
} from 'react'
import { getApiTargetInfo, yesNoMap, yesNoYNMap } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  getWind2CountryList,
  getWind2CountryState,
  getWind2timeZone,
  getWind2Entity,
  wind2AllPlant,
  wind2AllPlantSave,
  wind2AllPlantdelete,
  getWind2NercRegion,
  getWind2OwnershipStatus,
  getWind2CountryProvince,
  renameWind2Plant,
} from 'api/pgads'

import { Button, DatePicker, Input, InputNumber, Select } from 'antd'

import { ErrorContext } from 'context'
import R from 'ramda'

import { toSelectionColProps } from '@integec/grid-tools'
import moment from 'moment'
import { HistoryModal, RenameModal } from 'wind2/wind2utils'

const title = 'Wind Plant'

const Wind2Plant = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [availableStatus, setAvailableStatus] = useState({})
  const [regionMap, setRegionMap] = useState({})
  const [countryMap, setCountryMap] = useState({})
  const [entityMap, setEntityMap] = useState({})
  const [stateProvMap, setStateProvMap] = useState({})
  const [timeZoneMap, setTimeZoneMap] = useState({})
  const [countryProvinceMap, setCountryProvince] = useState({}) // for canada
  const [showRenameModal, setShowRenameModal] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)

  const { setError } = useContext(ErrorContext)

  useEffect(
    _ => {
      getWind2OwnershipStatus(apiTargetInfo).fork(setError, data => {
        const avaStatus = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.ownershipStatusCode]: d.ownershipStatusName,
          }))
        )
        setAvailableStatus(avaStatus)
      })

      getWind2NercRegion(apiTargetInfo).fork(setError, data => {
        const avaStatus = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.regionCode]: d.regionName,
          }))
        )
        setRegionMap(avaStatus)
      })

      getWind2CountryList(apiTargetInfo).fork(setError, data => {
        const counntryMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.countryId]: d.countryName,
          }))
        )
        setCountryMap(counntryMap)
      })

      getWind2CountryState(apiTargetInfo).fork(setError, data => {
        const stateProvMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.state]: d.stateName,
          }))
        )
        setStateProvMap(stateProvMap)
      })

      getWind2timeZone(apiTargetInfo).fork(setError, data => {
        const timezoneMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.timeZoneCode]: d.timeZoneName,
          }))
        )
        setTimeZoneMap(timezoneMap)
      })

      getWind2Entity(apiTargetInfo).fork(setError, data => {
        const timezoneMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.entityId]: d.entityId + ' - ' + d.entityName,
          }))
        )
        setEntityMap(timezoneMap)
      })

      getWind2CountryProvince(apiTargetInfo).fork(setError, data => {
        const stateProvMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.state]: d.stateName,
          }))
        )
        setCountryProvince(stateProvMap)
      })
    },
    [apiTargetInfo, setError]
  )

  const InsertComp = comProps => (
    <Wind2PlantModal
      {...comProps}
      insertEvent={insertEvent}
      setInsertEvent={setInsertEvent}
      availableStatus={availableStatus}
      countryMap={countryMap}
      stateProvMap={stateProvMap}
      timeZoneMap={timeZoneMap}
      entityMap={entityMap}
      regionMap={regionMap}
      countryProvinceMap={countryProvinceMap}
    />
  )
  const headerWithformater = useMemo(
    _ => {
      return Wind2PlantHeaders.map(header => {
        if (header.ident === 'region')
          return {
            ...header,
            dataFormatter: ({ value }) =>
              regionMap[value] ? value + '-' + regionMap[value] : value,
            sortIndexGetter: ({ rowData }) =>
              regionMap[rowData.region] || rowData.region,
            ...toSelectionColProps(regionMap),
          }
        if (header.ident === 'entityId')
          return {
            ...header,
            dataFormatter: ({ value }) => entityMap[value] || value,
            sortIndexGetter: ({ rowData }) =>
              entityMap[rowData.entityId] || rowData.entityId,
            width: 300,
            alignment: 'left',
            ellipsis: true,
          }
        if (header.ident === 'plantOwnershipStatus')
          return {
            ...header,
            dataFormatter: ({ value }) =>
              availableStatus[value]
                ? value + '-' + availableStatus[value]
                : value,
            sortIndexGetter: ({ rowData }) =>
              availableStatus[rowData.availableStatus] ||
              rowData.availableStatus,
            ...toSelectionColProps(availableStatus),
          }
        if (header.ident === 'country')
          return {
            ...header,
            dataFormatter: ({ value }) =>
              countryMap[value] ? value + '-' + countryMap[value] : value,
            sortIndexGetter: ({ rowData }) =>
              countryMap[rowData.country] || rowData.country,
            ...toSelectionColProps(countryMap),
          }
        if (header.ident === 'stateProvince')
          return {
            ...header,
            dataFormatter: ({ value, rowData }) => {
              return rowData.country === 'CA'
                ? countryProvinceMap[value] || value
                : stateProvMap[value] || value
            },
            sortIndexGetter: ({ rowData }) =>
              stateProvMap[rowData.stateProvince] || rowData.stateProvince,
            ...toSelectionColProps({ ...stateProvMap, ...countryProvinceMap }),
          }
        if (header.ident === 'timeZone')
          return {
            ...header,
            dataFormatter: ({ value }) =>
              timeZoneMap[value] ? value + '-' + timeZoneMap[value] : value,
            sortIndexGetter: ({ rowData }) =>
              timeZoneMap[rowData.timeZone] || rowData.timeZone,
            ...toSelectionColProps(timeZoneMap),
          }
        // if (header.ident === 'onSiteStorage')
        //   return {
        //     ...header,
        //     dataFormatter: ({ value }) => {
        //       return yesNoYNMap[value] ? yesNoYNMap[value] : value
        //     },
        //     sortIndexGetter: ({ rowData }) =>
        //       yesNoYNMap[rowData.onSiteStorage] || rowData.onSiteStorage,
        //     ...toSelectionColProps(yesNoMap),
        //   }

        return header
      })
    },
    [
      availableStatus,
      countryMap,
      stateProvMap,
      timeZoneMap,
      entityMap,
      regionMap,
      countryProvinceMap,
    ]
  )

  const modifySaveDataBeforeSave = saveData => {
    return saveData.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('YYYY-MM-DD'),
    }))
  }

  const sortOnData = data =>
    data.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('MM/DD/YYYY'),
    }))

  const extraCriteriaAfterButton = ({
    data,
    onRetrieve,
    apiTargetInfo,
    setSpinning,
  }) => {
    return (
      <div>
        {showRenameModal && (
          <RenameModal
            list={data.map(e => ({
              label: e.plantId,
              value: e.plantId + '||' + e.entityId,
            }))}
            modalFor="Plant"
            hide={() => setShowRenameModal(false)}
            onOk={data => {
              const { oldId, newId } = data
              const ids = oldId?.split('||')

              setSpinning(true)
              renameWind2Plant(apiTargetInfo)({
                oldId: ids[0],
                entityId: ids[1],
                newId,
              }).fork(setError, _ => {
                setSpinning(false)
                onRetrieve()
              })
            }}
          />
        )}
        {showHistoryModal && (
          <HistoryModal
            dataName="PLANT"
            apiTargetInfo={apiTargetInfo}
            setError={setError}
            hide={() => setShowHistoryModal(false)}
          />
        )}
        <Button
          onClick={() => setShowRenameModal(true)}
          type="primary"
          // style={{ marginLeft: '10px' }}
        >
          Rename Plant
        </Button>
        <Button
          onClick={() => setShowHistoryModal(true)}
          type="primary"
          style={{ marginLeft: '10px' }}
        >
          Show Rename History
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      sortOnData={sortOnData}
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      title={title}
      header={headerWithformater}
      saveTask={wind2AllPlantSave}
      retrieveTask={wind2AllPlant}
      deleteTask={wind2AllPlantdelete}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      altBy={d => d.entityId}
      autoRetrieve
      sortOptions={[
        strCol({
          ident: 'plantName',
          display: 'Plant Name',
          isKey: true,
          sortOrder: 'asc',
        }),
      ]}
      initialSortOptions={[
        strCol({
          ident: 'plantName',
          display: 'Plant Name',
          isKey: true,
          sortOrder: 'asc',
        }),
      ]}
      widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={60}
      defaultInsertData={{
        daylightSaving: 'N',
        plantOwnershipStatus: 'AV',
        onSiteStorage: 'N',
      }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2Plant)

const Wind2PlantModal = ({
  setInsertData,
  insertData,
  onAdd,
  onCancel,
  // setInsertEvent,
  // insertEvent,
  availableStatus = {},
  countryMap = {},
  stateProvMap = {},
  timeZoneMap = {},
  entityMap = {},
  regionMap = {},
  countryProvinceMap = {},
}) => {
  const getLabel = useCallback((key, isKey, isRequired) => {
    return (
      <div>
        {isKey && <span style={{ color: 'red', marginRight: '2px' }}>*</span>}
        {!isKey && isRequired && (
          <span style={{ color: 'red', marginRight: '2px' }}>*</span>
        )}
        {Wind2PlantHeaders.find(f => f.ident === key).display} :
      </div>
    )
  }, [])

  const getInput = useCallback(
    ({
      key,
      maxLength,
      isKey,
      insertData,
      setInsertData,
      isRequired = false,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Input
          disabled={insertData.insert && isKey}
          value={insertData[key]}
          data-cy={key}
          onChange={e =>
            setInsertData({ ...insertData, [key]: e.target.value })
          }
          maxLength={maxLength}
        />
      </div>
    ),
    [getLabel]
  )
  const getMapSelect = useCallback(
    ({
      key,
      keymap,
      isKey,
      getKeyMap,
      setInsertData,
      insertData,
      isRequired = false,
      extStyle = {},
      getExtraVal = _ => ({}),
    }) => (
      <div style={{ ...extStyle }}>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <Select
          disabled={insertData.insert && isKey}
          style={{ width: '100%', zIndex: 500 }}
          data-cy={key}
          value={insertData[key]}
          onChange={val =>
            setInsertData({ ...insertData, [key]: val, ...getExtraVal })
          }
        >
          {Object.keys(getKeyMap ? getKeyMap() : keymap).map(k => (
            <Select.Option value={k} key={k} data-cy={key}>
              {/* {`${k}-${keymap[k]}`} */}
              {`${getKeyMap ? getKeyMap()[k] : keymap[k]}`}
            </Select.Option>
          ))}
        </Select>
      </div>
    ),
    [getLabel]
  )

  const getInputNumber = useCallback(
    ({
      key,
      precision = 4,
      isKey = false,
      insertData,
      setInsertData,
      isRequired = false,
    }) => (
      <div>
        <span style={{ display: 'flex' }}>
          {getLabel(key, isKey, isRequired)}
        </span>
        <InputNumber
          disabled={insertData.insert && isKey}
          data-cy={key}
          style={{ width: '100%' }}
          value={insertData[key]}
          onChange={value =>
            setInsertData({ ...insertData, [key]: value + '' })
          }
          precision={precision}
        />
      </div>
    ),
    [getLabel]
  )
  const getDate = useCallback(
    ({ key, insertData, isKey, setInsertData, isRequired = false }) => (
      <div>
        {getLabel(key, isKey, isRequired)}
        <DatePicker
          style={{ width: '100%' }}
          data-cy={key}
          format="MM/DD/YYYY"
          value={insertData[key + 'date']}
          onChange={d => {
            setInsertData({
              ...insertData,
              [key]: d.format('YYYY-MM-DD'),
              [key + 'date']: d,
            })
          }}
        />
      </div>
    ),
    [getLabel]
  )

  return (
    <div
      style={{
        display: 'grid',
        // gridTemplateColumns: '200px 230px 230px 230px 230px 230px 230px',
        gridTemplateColumns: 'repeat(4, 285px)',
        gridTemplateRows: '60px 60px 60px',
        gridColumnGap: '10px',
        gridRowGap: '7px',
      }}
    >
      {/* {getInput({
        setInsertData,
        insertData,
        key: 'entityId',
        isKey: true,
      })} */}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'entityId',
        isKey: true,
        keymap: entityMap,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'region',
        isKey: true,
        keymap: regionMap,
        maxLength: 8,
      })}
      {/* {getInput({
        setInsertData,
        insertData,
        key: 'region',
        isKey: true,
      })} */}
      {getInput({
        setInsertData,
        insertData,
        key: 'plantId',
        isKey: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'plantName',
        isKey: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'eiaPlantCode',
        isKey: true,
        maxLength: 6,
      })}

      {getMapSelect({
        setInsertData,
        insertData,
        key: 'plantOwnershipStatus',
        isKey: true,
        keymap: availableStatus,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'isoResourceId',
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'timeZone',
        keymap: timeZoneMap,
        isRequired: true,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'daylightSaving',
        keymap: { Y: 'Yes', N: 'No' },
        isRequired: true,
      })}
      {getDate({
        setInsertData,
        insertData,
        key: 'effectiveDate',
        maxLength: 10,
        isRequired: true,
      })}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'country',
        keymap: countryMap,
        maxLength: 2,
        isRequired: true,
        getExtraVal: _ => ({ stateProvince: null }),
      })}

      {insertData.country !== 'CA' &&
        getMapSelect({
          setInsertData,
          insertData,
          key: 'stateProvince',
          keymap: stateProvMap,
          maxLength: 2,
          isRequired: true,
        })}
      {insertData.country === 'CA' &&
        getMapSelect({
          setInsertData,
          insertData,
          key: 'stateProvince',
          keymap: countryProvinceMap,
          maxLength: 2,
          isRequired: true,
        })}
      {getInput({
        setInsertData,
        insertData,
        key: 'nearestCity',
      })}
      {getInputNumber({
        setInsertData,
        insertData,
        key: 'latitude',
        isRequired: true,
      })}
      {getInputNumber({
        setInsertData,
        insertData,
        key: 'longitude',
        isRequired: true,
      })}
      {/* {getInput({
        setInsertData,
        insertData,
        key: 'onSiteStorage',
      })} */}
      {getMapSelect({
        setInsertData,
        insertData,
        key: 'onSiteStorage',
        keymap: { Y: 'Yes', N: 'No' },
        isRequired: true,
      })}
      {getInputNumber({
        setInsertData,
        insertData,
        key: 'plantCapPoi',
        isRequired: true,
      })}
      {getInput({
        setInsertData,
        insertData,
        key: 'transferToEntityId',
        maxLength: 10,
      })}
      <div
        style={{
          gridColumnEnd: 'span 3',
          display: 'grid',
          gridTemplateColumns: 'min-content max-content min-content',
          gap: 10,
          paddingBottom: '7px',
          alignContent: 'end',
        }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>

        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
}

export const Wind2PlantHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    width: 200,
    maxLength: 10,
  }),
  strCol({ ident: 'region', display: 'Region', isKey: true, width: 300 }),
  strCol({ ident: 'plantId', display: 'Plant ID', isKey: true, maxLength: 10 }),
  strCol({
    ident: 'plantName',
    display: 'Plant Name',
    isRequired: true,
    sortOrder: 'asc',
    width: 250,
    ellipsis: true,
  }),
  strCol({ ident: 'eiaPlantCode', display: 'EIA Plant Code', isKey: true }),
  strCol({ ident: 'isoResourceId', display: 'ISO ID', isFiltered: true }),

  strCol({
    ident: 'plantOwnershipStatus',
    display: 'Plant Ownership Status',
    isKey: false,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'country',
    display: 'Country',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'stateProvince',
    display: 'State/Province',
    isFiltered: true,
    width: 200,
    maxLength: 2,
    isRequired: true,
  }),
  strCol({
    ident: 'nearestCity',
    display: 'Nearest City',
    isFiltered: true,
    width: 200,
  }),

  strCol({
    ident: 'timeZone',
    display: 'Time Zone',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'daylightSaving',
    display: 'Daylight Saving',
    isFiltered: true,
    keymap: yesNoMap,
    isRequired: true,
    // ...toSelectionColProps(yesNoMap),
    ...toSelectionColProps(yesNoYNMap),
  }),
  strCol({
    ident: 'latitude',
    display: 'Latitude (DD)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'longitude',
    display: 'Longitude (DD)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'onSiteStorage',
    display: 'On-Site Storage (Yes/No)',
    isFiltered: true,
    isRequired: true,
    // keymap: yesNoYNMap,
    ...toSelectionColProps(yesNoYNMap),
    // ...toSelectionColProps(yesNoCAPMap)
  }),
  numCol({
    ident: 'plantCapPoi',
    display: 'Plant Capacity at POI (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'effectiveDate',
    display: 'Effective Date (mm/dd/yyyy)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'transferToEntityId',
    display: 'Transfer to Entity ID',
    isFiltered: true,
    maxLength: 10,
  }),

  modifierCol,
  modifiedDateCol,
].map(d => ({ ...d, ellipsis: true }))
